import React from 'react';
import styled from 'styled-components';

const StyledLoadMore = styled.button`
  text-decoration: underline;
  padding: 0rem 2rem;
  border: none;
  background-color: var(--white);
  cursor: pointer;
  display: flex;
  justify-content: center;
  width: 100%;
  position: absolute;
  bottom: 5rem;
  z-index: 3;
`;

const LoadMore = ({ onClick }) => {
  return (
    <StyledLoadMore className="body-l-semibold load-more" onClick={onClick}>
      Load More
    </StyledLoadMore>
  );
};

export default LoadMore;
